<template>
  <div id="restoreFieldList" v-if="isRestoredFields">

    <div class="header" style="margin-top: 20px;">
      <h3 class="ml-2">{{ title }}</h3>
      <span id="btn-close" @click="colseRestoredFieldsModal"><i class="fas fa-window-close"></i></span>
    </div>

    <br>
    <br>

    <template class="ml-2" id="field-list" v-if="fieldsList.length > 0" v-for="(field, index) in fieldsList">
      <div :key="index">
        <ul>
          <label for="">Page: {{ field.fieldPage }}</label>
          <li>
            {{ field.name }}
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isRestoredFields: false,
      fieldsList: [],
      title: ''
    }
  },

  created () {
    this.$bus.$on('showRestoredFieldsModal', (restoredFields) => {
      this.isRestoredFields = true

      if (restoredFields.isNotFileName) {
        this.title = 'File name does not match'
      } else if (restoredFields.length > 0) {
        this.fieldsList = restoredFields
        this.title = 'Restored Fields'
      } else this.title = 'There are no deleted fields'
    })
  },

  methods: {
    colseRestoredFieldsModal () {
      this.isRestoredFields = false

      this.fieldsList = []
    }
  }
}
</script>

<style lang="scss" scoped>
  #restoreFieldList {
    background-color: azure;
    position: absolute;
    width: 50%;
    margin-top: 10%;
    color: black;
    margin-left: 25%;
    border: 1px black solid;
    border-radius: 5px;
    box-shadow: 3px 2px 9px -1px black;
    z-index: 500;
    overflow: auto;
  }

  h2 {
    margin: 30px;
    display: inline;
  }

  #btn-close {
    position: absolute;
    display: inline;
    right: 10px;
    cursor: pointer;
    top: 2px;
  }

  #field-list {
    display: block;
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/modals/RestoredFieldsModal.vue